import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { usePermissions } from '@/context/PermissionsContext';

// Bloquea la ruta si el rol no tiene permiso "ver" en el módulo: redirige al Dashboard con aviso
// anyOf admite pares [modulo, accion] para permisos de otros módulos (p. ej. Verificar para quien atiende solicitudes de contratos)
export const RequirePermission = ({ module, action = 'ver', anyOf, children }) => {
  const { can, ready } = usePermissions();
  const okAny = (a) => (Array.isArray(a) ? can(a[0], a[1]) : can(module, a));
  const allowed = !ready || (anyOf ? anyOf.some(okAny) : can(module, action));
  useEffect(() => {
    if (ready && !allowed) toast.error('No tienes acceso a esta sección', { id: 'rbac-denied-section' });
  }, [ready, allowed]);
  if (!allowed) return <Navigate to="/app" replace />;
  return children;
};

export default RequirePermission;
